import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import * as PropTypes from 'prop-types';

import sx from '../../internal/styles/sx';

const BaseSeparator = styled('div')(
  ({ orientation, type }) =>
    css(
      orientation === 'vertical'
        ? {
            display: 'flex',
            borderLeft: `0.5px ${type}`,
            borderRight: `0.5px ${type}`,
            borderColor: 'neutrals.5',
            height: '100%',
            minHeight: '50px',
            width: '0px',
          }
        : {
            display: 'flex',
            borderBottom: `0.5px ${type}`,
            borderTop: `0.5px ${type}`,
            borderColor: 'neutrals.5',
            height: '0px',
            width: '100%',
          }
    ),
  sx
);

const TicketSeparator = ({
  type = 'dashed',
  orientation = 'vertical',
  ...rest
}) => {
  return <BaseSeparator type={type} orientation={orientation} {...rest} />;
};

TicketSeparator.propTypes = {
  type: PropTypes.oneOf(['solid', 'dashed', 'dotted']),
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
};

export default TicketSeparator;
